import axios from 'axios';
import authHeaders from './auth-header';

const DOWNLOAD_COMMENTS_URL = process.env.VUE_APP_BASE_AP_URL+`/download/session-comments`;
const EXPORT_AGENDA_URL = process.env.VUE_APP_BASE_AP_URL+`/exports/agenda`;

export async function downloadComments(sessionsIds) {
	return axios.post(`${DOWNLOAD_COMMENTS_URL}`, {'sessionIds' : sessionsIds}, {responseType: 'arraybuffer', headers : { 'Authorization':authHeaders()}})
	.then(response => {
      if(response.data) {
          return Promise.resolve(response.data);
      }
	})
	.catch(error => {
      return Promise.reject(error.response);
	});
}

export async function exportAgenda(startDate, endDate) {
	return axios.get(`${EXPORT_AGENDA_URL}`, {responseType: 'arraybuffer', headers : { 'Authorization':authHeaders()}, params: { startDate, endDate }})
	.then(response => {
      if(response.data) {
          return Promise.resolve(response.data);
      }
	})
	.catch(error => {
      return Promise.reject(error.response);
	});
}
